"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DayPickerRangeController = DayPickerRangeController;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _styles = require("@material-ui/core/styles");
require("@proofpoint/react-dates/initialize");
require("@proofpoint/react-dates/lib/css/_datepicker.css");
var _reactDates = require("@proofpoint/react-dates");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _withReactDatesStyles = _interopRequireDefault(require("../../theme/react-dates/withReactDatesStyles"));
var _excluded = ["classes", "className", "endDate", "focusedInput", "isOutsideRange", "onDatesChange", "onFocusChange", "onHoverDateChange", "startDate", "todayUTCOffset", "useUtc"];
var styles = function styles( /* theme */
) {
  return {
    root: {
      height: 364,
      width: 672
    }
  };
};

/**
 * This component is based on Airbnb's react-dates.
 *
 * The `DayPickerRangeController` component is a fully controlled component
 * that has built-in rules for selecting a date range. The consumer needs
 * simply to maintain the `focusedInput`, `startDate`, and `endDate` values in state
 * and then pass these down as props along with `onFocusChange` and `onDatesChange`
 * callbacks that update them appropriately.
 *
 * Note that the `focusedInput` prop may be null, but if this is the case,
 * dates are not selectable.
 *
 * The `DayPickerRangeController` is particularly useful if you are interested in
 * the `DateRangePicker` functionality and calendar presentation, but would like
 * to implement your own inputs.
 */
function DayPickerRangeController(_ref) {
  var classes = _ref.classes,
    className = _ref.className,
    endDate = _ref.endDate,
    focusedInput = _ref.focusedInput,
    isOutsideRange = _ref.isOutsideRange,
    onDatesChange = _ref.onDatesChange,
    onFocusChange = _ref.onFocusChange,
    onHoverDateChange = _ref.onHoverDateChange,
    startDate = _ref.startDate,
    todayUTCOffset = _ref.todayUTCOffset,
    useUtc = _ref.useUtc,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var componentStartDate = startDate;
  var componentEndDate = endDate;
  var componentTodayUTCOffset = todayUTCOffset;
  var componentIsOutsideRange = isOutsideRange;
  if (useUtc) {
    componentStartDate = startDate !== null ? _moment["default"].utc(startDate) : null;
    componentEndDate = endDate !== null ? _moment["default"].utc(endDate) : null;
    componentTodayUTCOffset = !todayUTCOffset ? '+00:00' : todayUTCOffset;
    componentIsOutsideRange = typeof isOutsideRange === 'function' ? function (day) {
      return isOutsideRange(_moment["default"].utc(day));
    } : undefined;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, className)
  }, /*#__PURE__*/_react["default"].createElement(_reactDates.DayPickerRangeController
  // Received props
  , (0, _extends2["default"])({
    endDate: componentEndDate,
    focusedInput: focusedInput,
    isOutsideRange: componentIsOutsideRange,
    onDatesChange: onDatesChange,
    onFocusChange: onFocusChange,
    onHoverDateChange: onHoverDateChange,
    startDate: componentStartDate,
    todayUTCOffset: componentTodayUTCOffset
    // Override props
    ,
    minimumNights: 0,
    numberOfMonths: 2
  }, rest)));
}
DayPickerRangeController.defaultProps = {
  classes: {},
  useUtc: false
};
DayPickerRangeController.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The end date of the date range. (Moment Object)
   * If endDate is undefined, endDate gets set to today's date
   */
  endDate: _propTypes["default"].object,
  /**
   * The input that is currently focused. If focusedInput is startDate, it also
   * means startDate has been set.
   */
  focusedInput: _propTypes["default"].oneOf(['startDate', 'endDate']),
  /**
   * A predicate function that returns if the date is valid, which would allow
   * you to restrict which dates are selectable.
   *
   * @param {object} date the date to be evaluated if it is outside of the range
   */
  isOutsideRange: _propTypes["default"].func,
  /**
   * @ignore
   */
  navNext: _propTypes["default"].element,
  /**
   * @ignore
   */
  navPrev: _propTypes["default"].element,
  /**
   * Callback fired when the date range is changed.
   *
   * @param {object} startDate the start date of the date range. (Moment Object)
   * @param {object} endDate the end date of the date range. (Moment Object)
   */
  onDatesChange: _propTypes["default"].func,
  /**
   * Callback fired when the focused input is changed.
   *
   * @param {string} focusedInput the current focused input.
   */
  onFocusChange: _propTypes["default"].func,
  /**
   * Callback fired when hovering on a date.
   *
   * @param {object} date the hovered date (Moment Object)
   */
  onHoverDateChange: _propTypes["default"].func,
  /**
   * @ignore
   */
  renderDayContents: _propTypes["default"].func,
  /**
   * @ignore
   */
  renderMonthElement: _propTypes["default"].func,
  /**
   * The start date of the date range. (Moment Object)
   * If startDate is undefined, startDate gets set to today's date
   */
  startDate: _propTypes["default"].object,
  /**
   * Set timezone offset for today's date, use "-07:00" format, integers don't work
   * https://momentjs.com/docs/#/manipulating/utc-offset/
   */
  todayUTCOffset: _propTypes["default"].string,
  /**
   * Sets dates in the day picker to use UTC over local times
   */
  useUtc: _propTypes["default"].bool
} : {};
var ExportComponent = (0, _withReactDatesStyles["default"])((0, _styles.withStyles)(styles)(DayPickerRangeController));
ExportComponent.displayName = 'DayPickerRangeController';
var _default = ExportComponent;
exports["default"] = _default;